import axios from 'axios';
import { GET_BRANCH, GET_SHOWROOMS_BY_IP, GET_SHOWROOMS, GET_SHOWROOM_BY_IP, GET_SHOWROOM, GET_SHOWROOM_BY_ID, GET_LOWES_STORES_BY_IP, GET_LOWES_STORES, GET_LOWES_STORE_BY_IP, GET_LOWES_STORE, GET_CONTRACTORS, GET_STORES, GET_MARKET_BY_IP, GET_MARKET, GET_SERVICE_INFO, GET_BETA, RESET_SHOWROOMS, RESET_LOWES, RESET_CONTRACTORS, RESET_STORES, RESET_MARKET, RESET_LOCATION_SERVICE, GET_ERRORS } from './types';
import { isCrawler } from '../components/utilities/functions';
import { clearErrors } from './utilities';
import { HandleAxiosError } from '../hooks/utils/axiosError';

const pellaAPIURL = process.env.GATSBY_PELLA_API;
const rtaZoneConfig = {
	headers: {
		Authorization: 'Bearer ' + process.env.GATSBY_PELLA_RTA_API_TOKEN,
	},
};

// Territory Zone
export const getBranch = (postalCode) => (dispatch) => {
	if (!isCrawler()) {
		dispatch(clearErrors());
		axios
			.get(`${pellaAPIURL}/location/v2/branch/${postalCode}`, rtaZoneConfig)
			.then((res) =>
				dispatch({
					type: GET_BRANCH,
					payload: res.data,
				})
			)
			.catch((error) =>
				dispatch({
					type: GET_ERRORS,
					payload: error,
				})
			);
	}
};
// END Territory Zone

// Showrooms
export const getShowroomsByIP =
	(coordinates = null) =>
	(dispatch) => {
		dispatch(clearErrors());
		const params = {};
		if (coordinates) {
			params.lon = coordinates[0];
			params.lat = coordinates[1];
		}
		axios
			.get(`${pellaAPIURL}/location/v2/showrooms`, { params: params })
			.then((res) =>
				dispatch({
					type: GET_SHOWROOMS_BY_IP,
					payload: res.data,
				})
			)
			.catch((error) =>
				dispatch({
					type: GET_ERRORS,
					payload: error,
				})
			);
	};

export const getShowrooms =
	(postalCode, trigger = 'POSTAL_UPDATE') =>
	(dispatch) => {
		dispatch(clearErrors());
		axios
			.get(`${pellaAPIURL}/location/v2/showrooms/${postalCode}`)
			.then((res) =>
				dispatch({
					type: GET_SHOWROOMS,
					payload: res.data,
					event: trigger,
				})
			)
			.catch((error) =>
				dispatch({
					type: GET_ERRORS,
					payload: error,
					event: trigger,
				})
			);
	};

export const getAllShowrooms = async () => {
	try {
		const response = await axios.get(`${pellaAPIURL}/location/v2/export/showrooms`);
		return response.data;
	} catch (error) {
		return HandleAxiosError(error);
	}
};

export const getShowroomByIP =
	(coordinates = null) =>
	(dispatch) => {
		dispatch(clearErrors());
		const params = {};
		if (coordinates) {
			params.lon = coordinates[0];
			params.lat = coordinates[1];
		}
		axios
			.get(`${pellaAPIURL}/location/v2/showroom`, { params: params })
			.then((res) =>
				dispatch({
					type: GET_SHOWROOM_BY_IP,
					payload: res.data,
				})
			)
			.catch((error) =>
				dispatch({
					type: GET_ERRORS,
					payload: error,
				})
			);
	};

export const getShowroom = (postalCode) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(`${pellaAPIURL}/location/v2/showroom/${postalCode}`)
		.then((res) =>
			dispatch({
				type: GET_SHOWROOM,
				payload: res.data,
			})
		)
		.catch((error) =>
			dispatch({
				type: GET_ERRORS,
				payload: error,
			})
		);
};

export const getShowroomByID = (showroomID) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(`${pellaAPIURL}/location/v2/info/showroom/${showroomID}`)
		.then((res) =>
			dispatch({
				type: GET_SHOWROOM_BY_ID,
				payload: res.data,
			})
		)
		.catch((error) =>
			dispatch({
				type: GET_ERRORS,
				payload: error,
			})
		);
};
// END Showrooms

// Lowes
export const getLowesStoresByIP =
	(coordinates = null) =>
	(dispatch) => {
		dispatch(clearErrors());
		const params = {};
		if (coordinates) {
			params.lon = coordinates[0];
			params.lat = coordinates[1];
		}
		axios
			.get(`${pellaAPIURL}/location/v2/lowes`, { params: params })
			.then((res) =>
				dispatch({
					type: GET_LOWES_STORES_BY_IP,
					payload: res.data,
				})
			)
			.catch((error) =>
				dispatch({
					type: GET_ERRORS,
					payload: error,
				})
			);
	};

export const getLowesStores = (postalCode) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(`${pellaAPIURL}/location/v2/lowes/${postalCode}`)
		.then((res) =>
			dispatch({
				type: GET_LOWES_STORES,
				payload: res.data,
			})
		)
		.catch((error) =>
			dispatch({
				type: GET_ERRORS,
				payload: error,
			})
		);
};

export const getLowesStoreByIP =
	(coordinates = null) =>
	(dispatch) => {
		dispatch(clearErrors());
		const params = {};
		if (coordinates) {
			params.lon = coordinates[0];
			params.lat = coordinates[1];
		}
		axios
			.get(`${pellaAPIURL}/location/v2/lowes-store`, { params: params })
			.then((res) =>
				dispatch({
					type: GET_LOWES_STORE_BY_IP,
					payload: res.data,
				})
			)
			.catch((error) =>
				dispatch({
					type: GET_ERRORS,
					payload: error,
				})
			);
	};

export const getLowesStore = (postalCode) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(`${pellaAPIURL}/location/v2/lowes-store/${postalCode}`)
		.then((res) =>
			dispatch({
				type: GET_LOWES_STORE,
				payload: res.data,
			})
		)
		.catch((error) =>
			dispatch({
				type: GET_ERRORS,
				payload: error,
			})
		);
};
// END Lowes

// Contractors
export const getContractors = (postalCode, radius) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(`${pellaAPIURL}/location/v2/contractors/${postalCode}?radius=${radius}`)
		.then((res) =>
			dispatch({
				type: GET_CONTRACTORS,
				payload: res.data,
			})
		)
		.catch((error) =>
			dispatch({
				type: GET_ERRORS,
				payload: error,
			})
		);
};
// END Contractors

// Service Information
export const getServiceInfo = (postalCode) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(`${pellaAPIURL}/location/v2/service/${postalCode}`)
		.then((res) =>
			dispatch({
				type: GET_SERVICE_INFO,
				payload: res.data,
			})
		)
		.catch((error) =>
			dispatch({
				type: GET_ERRORS,
				payload: error,
			})
		);
};
// END Service Information

// Stores
export const getStores = (postalCode) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(`${pellaAPIURL}/location/v2/stores/${postalCode}`)
		.then((res) =>
			dispatch({
				type: GET_STORES,
				payload: res.data,
			})
		)
		.catch((error) =>
			dispatch({
				type: GET_ERRORS,
				payload: error,
			})
		);
};
// END Stores

// Beta Market
export const getMarketByIP =
	(coordinates = null) =>
	(dispatch) => {
		dispatch(clearErrors());
		const params = {};
		if (coordinates) {
			params.lon = coordinates[0];
			params.lat = coordinates[1];
		}
		axios
			.get(`${pellaAPIURL}/location/v2/ecommerce/market`, {
				params: params,
			})
			.then((res) =>
				dispatch({
					type: GET_MARKET_BY_IP,
					payload: res.data,
				})
			)
			.catch((error) =>
				dispatch({
					type: GET_ERRORS,
					payload: error,
				})
			);
	};

export const getMarket = (postalCode) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(`${pellaAPIURL}/location/v2/ecommerce/market/${postalCode}`)
		.then((res) =>
			dispatch({
				type: GET_MARKET,
				payload: res.data,
			})
		)
		.catch((error) =>
			dispatch({
				type: GET_ERRORS,
				payload: error,
			})
		);
};
// END Beta Market

// Beta Call
export const getBeta = (postalCode) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(`${pellaAPIURL}/location/v2/beta/${postalCode}`)
		.then((res) =>
			dispatch({
				type: GET_BETA,
				payload: res.data,
			})
		)
		.catch((error) =>
			dispatch({
				type: GET_ERRORS,
				payload: error,
			})
		);
};
// END Beta Market

// Directory Call
export const getDirectory = async (postalCode, include, radius) => {
	try {
		let config = {
			withCredentials: true,
			params: {},
		};

		if (include?.[0]) {
			config.params.include = include.join(',');
		}
		if (radius) {
			config.params.radius = radius;
		}

		const response = await axios.get(`${pellaAPIURL}/location/v2/directory/${postalCode}`, config);
		return response;
	} catch (error) {
		if (error.response?.data) {
			return error.response.data;
		} else {
			return { success: false };
		}
	}
};

// Showrooms by Branch
export const getShowroomsByBranch = async (branch_id) => {
	try {
		let config = {
			withCredentials: true,
		};

		const response = await axios.get(`${pellaAPIURL}/location/v2/branch/${branch_id}/showrooms`, config);
		return response;
	} catch (error) {
		if (error.response?.data) {
			return error.response.data;
		} else {
			return { success: false };
		}
	}
};

// Service Area Map Place IDs
export const getServiceAreaPlaceIds = async (branchID) => {
	try {
		const response = await axios.get(`${pellaAPIURL}/location/v2/branch/service-area/${branchID}`);
		return response.data;
	} catch (error) {
		return HandleAxiosError(error);
	}
};

// Reset Showrooms state
export const resetShowrooms = () => ({
	type: RESET_SHOWROOMS,
});

// Reset Lowes state
export const resetLowes = () => ({
	type: RESET_LOWES,
});

// Reset Contractors state
export const resetContractors = () => ({
	type: RESET_CONTRACTORS,
});

// Reset Stores state
export const resetStores = () => ({
	type: RESET_STORES,
});

// Reset Beta Market
export const resetMarket = () => ({
	type: RESET_MARKET,
});

// Reset location services state
export const resetLocations = () => ({
	type: RESET_LOCATION_SERVICE,
});
